import React, { Component } from 'react';

class MemberOf extends Component {
  render() {
    return (
      <section className="container">
        <div className="row">
          <div className="col-xs-10 col-xs-offset-1">
            <h2 className="text-center heading">Proud <strong>Members of</strong></h2><br />
            <a href="//www.mbansw.asn.au" target="_blank" rel="nofollow noopener noreferrer">
              <img src="https://res.cloudinary.com/cna-net-au/image/upload/c_scale,w_320/v1537781022/misc/MBALogo-white.jpg"
                alt="Master Builders Association NSW" className="center img-responsive lazyload" />
            </a>
          </div>
        </div>
      </section>
    );
  }
}

export default MemberOf;



// WEBPACK FOOTER //
// ./src/components/MemberOf.js